/**
*
* ConversationsBackButton
*
*/

import React from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';
import BackButton from 'components/interaction/BackButton/index.jsx';

function ConversationsBackButton(props) {
  const { postfix } = props;
  const { inboxId } = useParams();
  return <BackButton to={`/conversations/inboxes/${inboxId}${[postfix]}`} size="sm" className="me-3" />;
}

ConversationsBackButton.propTypes = {
  postfix: PropTypes.string,
};

export default ConversationsBackButton;
